import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_BRAND_TITLE':
    case 'UPDATE_BRAND_BANNER':
    case 'UPDATE_BRAND_ICON':
    case 'UPDATE_BRAND_SLUG':
    case 'UPDATE_BRAND_DESCRIPTION':
    case 'UPDATE_BRAND_PICTURES':
    case 'UPDATE_BRAND_VIDEOS':
    case 'UPDATE_BRAND_SEO':
    case 'UPDATE_BRAND_STEP': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
